<template>
  <div>
    <small class="label">{{ $l.emailAddress }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="email"
      :placeholder="$l.userEmail"
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    email: {
      get: function () {
        return this.$store.state.user.email
      },

      set: function (email) {
        this.$store.commit('user/setEmail', email)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
